import { render, staticRenderFns } from "./packagesize.vue?vue&type=template&id=19a93129"
import script from "./packagesize.vue?vue&type=script&lang=js"
export * from "./packagesize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports